import React from 'react';
import './WorkFooter.css';
import { useBrowserInfo } from '../hooks/useBrowserInfo';
import { HugeiconsIcon } from '@hugeicons/react';
import { ThreeDRotateIcon, PerspectiveIcon } from '@hugeicons-pro/core-stroke-sharp';
import { ThreeDRotateIcon as ThreeDRotateIconSolid, DarkModeIcon as DarkModeIconSolid, PerspectiveIcon as PerspectiveIconSolid } from '@hugeicons-pro/core-solid-sharp';
import { motion } from 'framer-motion';

// Footer component
function WorkFooter({
  isZoomed = false,
  wireframeEnabled = false,
  onToggleWireframe = undefined,
  gridEnabled = false,
  onToggleGrid = undefined
}) {
  const { windowSize } = useBrowserInfo();
  const isMobile = windowSize.width <= 768;

  return (
    <motion.footer
      className="footer"
      initial={false}
      animate={{ y: isZoomed ? '120%' : 0 }}
      transition={{ type: 'tween', ease: [0.22, 1, 0.36, 1], duration: 0.38 }}
    >
      <div className="footer-content">

        <div className="footer-col footer-col-left">
          <span>{windowSize.width} x {windowSize.height}</span>
        </div>

        <div className="footer-col footer-col-right">
          <div className="scene-controls">

            <a
              onClick={() => {
                if (onToggleGrid) onToggleGrid(!gridEnabled);
              }}
              aria-label="Toggle grid"
              title="Toggle grid"
              aria-pressed={!!gridEnabled}
            >
              <HugeiconsIcon icon={gridEnabled ? PerspectiveIconSolid : PerspectiveIcon} size={16} color="currentColor" />
            </a>

            <a
              onClick={() => {
                if (onToggleWireframe) onToggleWireframe(!wireframeEnabled);
              }}
              araria-label="Toggle wireframe"
              title="Toggle wireframe"
              aria-pressed={!!wireframeEnabled}
            >
              <HugeiconsIcon icon={wireframeEnabled ? ThreeDRotateIconSolid : ThreeDRotateIcon} size={16} color="currentColor" />
            </a>

          </div>

        </div>


      </div>
    </motion.footer>
  );
}

export default WorkFooter;
